import { defineMessages } from 'react-intl';

export default defineMessages({
  TITLE: {
    defaultMessage: 'Fonds insuffisants',
  },

  DESCRIPTION: {
    defaultMessage: 'Vous avez atteint votre quota actuel.',
  },

  DEFAULT_BANNER_CONTENT: {
    defaultMessage:
      'Une nouvelle allocation de <b>{monthlyCredits} crédits</b> sera ajoutée automatiquement dans <b>{daysUntilRefill} {daysUntilRefill, plural, one {jour} other {jours}}</b>.',
  },

  DEFAULT_NOT_ELIGIBLE_BANNER_CONTENT: {
    defaultMessage:
      "Votre soif d'apprendre est insatiable ! Vous n'avez plus suffisamment de crédits pour débloquer ce contenu.",
  },

  DISCOVERY_BANNER_CONTENT: {
    defaultMessage:
      'Ce contenu sera disponible à la fin votre période d’engagement, dans <b>{days} {days, plural, one {jour} other {jours}}</b>.',
  },
} as const);
